export function hashString(str) {
  if (str?.length) {
    let h;
    for (let i = 0; i < str.length; i++) h = (Math.imul(31, h) + str.charCodeAt(i)) | 0;

    return h;
  }
  return '';
}
